import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo/logo.svg';
import henceforthApi from '../utils/henceforthApi';
import Spinner from '../components/common/spinner';
import { handleError } from '../context/Provider';

const PrivacyPolicyActivity = () => {
    const [content, setContent] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);

    const fetchPrivacyPolicyContent = async () => {
        setLoading(true);
        try {
            const res = await henceforthApi.Content.getContent('PRIVACY_POLICY', 'ENGLISH');
            if (res?.data?.description) {
                setContent(res.data.description);
            }
        } catch (err: any) {
            console.error('Error fetching privacy policy content:', err);
            handleError(err, '', () => { });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPrivacyPolicyContent();
    }, []);

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="common-card p-4">
                        <div className="text-center mb-4">
                            <img src={logo} width={150} alt="Yonna Logo" />
                            <h2 className="mt-3 fw-bold">Privacy Policy</h2>
                        </div>
                        {loading ? (
                            <div className="d-flex justify-content-center py-5">
                                <Spinner color={'text-success'} />
                            </div>
                        ) : (
                            <div className="content-box">
                                {content ? (
                                    <div dangerouslySetInnerHTML={{ __html: content }} />
                                ) : (
                                    <p className="text-center text-muted">No content available</p>
                                )}
                            </div>
                        )}
                        {/* <div className="text-center mt-5">
                            <Link to="/" className="btn btn-theme px-5">Back to Login</Link>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyActivity;
